import { ApolloLink } from '@apollo/client'

import { Customer } from 'Types'

import cache from '../cache'

const authLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((result) => {
    switch (operation.operationName) {
      case 'SignUpCustomer': {
        const customer = result.data?.signUpCustomer?.customer
        if (customer) {
          cache.modify({
            fields: {
              currentCustomer() {
                return {
                  ...(customer as Customer),
                  __typename: 'Customer',
                }
              },
            },
          })
        }
        break
      }
      case 'LogoutCustomer':
        cache.modify({
          fields: {
            currentCustomer() {
              return null
            },
          },
        })
        break
    }

    return result
  })
})

export default authLink
